var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg404 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45 2.5H3a.5.5 0 0 0-.5.5v2h43V3a.5.5 0 0 0-.5-.5ZM1 5v40a2 2 0 0 0 2 2h42a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v2Zm44.5 40V6.5h-43V45a.5.5 0 0 0 .5.5h42a.5.5 0 0 0 .5-.5ZM24 33c-.803 0-1.492-.11-2.066-.332a3.491 3.491 0 0 1-1.435-1.064c-.37-.488-.644-1.108-.823-1.862-.178-.764-.268-1.678-.268-2.742s.09-1.972.268-2.726c.179-.764.453-1.385.823-1.861.383-.488.86-.842 1.435-1.064C22.508 21.116 23.196 21 24 21c.803 0 1.492.116 2.066.349a3.181 3.181 0 0 1 1.416 1.064c.383.476.663 1.097.842 1.861.178.754.268 1.662.268 2.726s-.09 1.978-.268 2.742c-.179.754-.46 1.374-.842 1.862-.37.476-.842.83-1.416 1.064-.574.221-1.262.332-2.066.332Zm0-1.994c.319 0 .587-.04.803-.117.217-.088.39-.221.517-.399a1.85 1.85 0 0 0 .268-.731c.064-.3.096-.67.096-1.114v-3.29c0-.876-.122-1.485-.364-1.829-.242-.354-.682-.532-1.32-.532s-1.078.178-1.32.532c-.242.344-.364.953-.364 1.829v3.29c0 .444.026.815.077 1.114.064.3.16.543.287.731.128.178.3.31.517.4.216.077.484.116.803.116ZM14.223 32.8v-2.194H9v-2.028l4.324-7.38h3.482v7.546h1.53v1.862h-1.53V32.8h-2.583Zm-3.157-4.056h3.157v-5.169h-.306l-2.85 5.17Zm23.82 1.862V32.8h2.583v-2.194H39v-1.862h-1.53V21.2h-3.483l-4.323 7.38v2.028h5.223Zm0-1.862H31.73l2.85-5.169h.307v5.17Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg404);
export default ForwardRef;